import React, { Component } from 'react';




import { apiPut, apiPost, apiDelete } from '../../Api';
import LevelList from './Admin_Level_List';
import LevelDetail from './Admin_Level_Detail';
import AdminAPI from './AdminAPI';
import './Admin_Level.css';

export default class Admin_Level extends Component {


  constructor(props) {
    super(props);
    this.state = {
      Level: [], // Load this from your backend
      stats: [],
      creatingNewLevel: false,
      selectedLevelId: ""
    }
  }

  componentDidMount = async () => {
    this.setState({ stats: await AdminAPI.getStats() });
    this.setState({ Level: await AdminAPI.getLevels() });
  }

  handleSelectLevel = (Level) => {

    this.setState({
      selectedLevel: Level,
      creatingNewLevel: false,
      selectedLevelId: Level.id,
    });

  };

  handleNewLevel = () => {
    this.setState({
      creatingNewLevel: true,
      selectedLevel: {},
      selectedLevelId: ""
    });
  };


  handleCancelCreate = () => {
    this.setState({
      selectedLevel: null,
      creatingNewLevel: false,
    });
  };

  handleUpdate = async (Level) => {
    const response = await apiPut("/Level", JSON.stringify(Level));
    if (response.ok) {
      this.setState({ Level: await AdminAPI.getLevels() });
      this.setState({ selectedLevelId: null });
    }
  };

  handleDelete = async (Level) => {
    // Send delete request to your backend
    const response = await apiDelete("/Level/" + Level.id);
    if (response.ok) {
      this.setState({ Level: await AdminAPI.getLevels() });
      this.setState({ selectedLevelId: null });
    }
  };

  handleCreate = async (Level) => {
    // Send delete request to your backend
    const response = await apiPost("/Level", JSON.stringify(Level));

    if (response.ok) {

      this.setState({ Level: await AdminAPI.getLevels() });
      this.setState({ selectedLevelId: null });
    }
    else {
      window.alert(response.text());
    }
  };

  handleSearch = (searchQuery) => {
    // Filter the Level based on search query
  };



  // findSelectedLevel = () => {

  //   return this.state.Level.find((c) => c.id === this.state.selectedLevelId);

  // }



  render() {
    const { Level, creatingNewLevel } = this.state;

    return (
      <div className="admin-settingspage">
        <LevelList
          Level={Level}
          filter={this.props.filter}
          regions={this.props.regions}
          stats={this.state.stats}
          selectedLevelId={this.state.selectedLevelId}
          onSelectLevel={this.handleSelectLevel}
          onSearch={this.handleSearch}
          onNewLevel={this.handleNewLevel}
        />



        <LevelDetail
          creatingNewLevel={creatingNewLevel}
          stats={this.state.stats}
          LevelId={this.state.selectedLevelId}
          onUpdate={this.handleUpdate}
          onDelete={this.handleDelete}
          onCreate={this.handleCreate}
          onCancelCreate={this.handleCancelCreate}
        />

      </div>
    );
  }
}
